import { useContext } from 'react';
import { OverlayContext, OverlayContextProps } from '../context/overlay';

export const useOverlay = (): OverlayContextProps => useContext(OverlayContext);
